class CartDrawer extends HTMLElement {
    constructor() {
        super(), this.addEventListener("keyup", evt => evt.code === "Escape" && this.close()), this.addEventListener("click", event => {
            event.target instanceof Element && event.target.id === "CartDrawer-Overlay" && this.onOverlayClick(event)
        }), this.addEventListener("click", event => {
            const removeBtn = event.target instanceof Element ? event.target.closest("[data-gift-promo-remove]") : null;
            !removeBtn || !this.contains(removeBtn) || (event.preventDefault(), event.stopPropagation(), this.removeCustomerPromoCodes(removeBtn))
        }), window.addEventListener("resize", () => this.updateFooterOffset()), this.setHeaderCartIconAccessibility(), this.bindGiftPanel(), this.bindGiftVariantSelect(), this.bindUpsellPanel(), this.installCustomerPromoDiscountGuard(), this._wasGiftEligible = this.querySelector("[data-cart-gifts]")?.dataset.autoOpen === "true", this._unlockedGiftTiers = this.getUnlockedGiftTiers(), this.addEventListener("click", event => {
            this.ensureGiftDiscountBeforeCheckout(event)
        }), typeof subscribe == "function" && typeof PUB_SUB_EVENTS < "u" && (subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.paintUpsellFromCache()), subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
            requestAnimationFrame(() => {
                this.bindGiftPanel(), this.bindUpsellPanel(), this.animateProgressFill(), this.maybeAutoOpenGiftsAfterEligibilityChange(), this.autoApplyGiftDiscount(), this.syncGiftsWithCustomerPromo()
            })
        }))
    }
    getUnlockedGiftTiers() {
        return [...this.querySelectorAll(".cart-progress__milestone.is-gift.is-unlocked[data-progress-gift-tier]")].map(el => el.getAttribute("data-progress-gift-tier")).filter(Boolean)
    }
    captureProgressFill() {
        const fill = this.querySelector(".cart-progress__fill");
        if (!fill) {
            this._progressFillFrom = null;
            return
        }
        this._progressFillFrom = fill.getBoundingClientRect().width
    }
    animateProgressFill() {
        const fill = this.querySelector(".cart-progress__fill"),
            progress = this.querySelector(".cart-progress");
        if (!fill || !progress) return;
        const target = (progress.style.getPropertyValue("--cart-progress-fill") || fill.style.width || "0%").trim() || "0%",
            fromPx = this._progressFillFrom;
        fromPx == null || Number.isNaN(fromPx) || (fill.style.transition = "none", fill.style.width = `${fromPx}px`, fill.offsetWidth, fill.style.transition = "", requestAnimationFrame(() => {
            fill.style.width = target
        }), this._progressFillFrom = null)
    }
    setHeaderCartIconAccessibility() {
        const cartLinks = document.querySelectorAll("#cart-icon-bubble, a.abb-header__icon--cart, a.header__icon--cart");
        cartLinks.length && cartLinks.forEach(cartLink => {
            cartLink.setAttribute("role", "button"), cartLink.setAttribute("aria-haspopup", "dialog"), cartLink.addEventListener("click", event => {
                event.preventDefault(), this.open(cartLink)
            }), cartLink.addEventListener("keydown", event => {
                event.code.toUpperCase() === "SPACE" && (event.preventDefault(), this.open(cartLink))
            })
        })
    }
    bindGiftVariantSelect() {
        this._giftVariantSelectBound || (this._giftVariantSelectBound = !0, this.addEventListener("change", event => {
            const select = event.target instanceof Element ? event.target.closest("[data-gift-variant-select]") : null;
            if (!select) return;
            const card = select.closest("[data-gift-open]");
            if (!card) return;
            const oldId = String(card.dataset.variantId || ""),
                newId = String(select.value || "");
            if (!newId || oldId === newId) return;
            const option = select.options[select.selectedIndex],
                baseTitle = card.dataset.giftBaseTitle || "",
                newTitle = baseTitle && option ? `${baseTitle} \u2013 ${option.text.trim()}` : "",
                update = el => {
                    el.dataset.variantId = newId, newTitle && el.hasAttribute("data-gift-product-title") && (el.dataset.giftProductTitle = newTitle)
                };
            update(card), card.querySelectorAll("[data-variant-id]").forEach(update);
            const gifts = this.querySelector("[data-cart-gifts]");
            if (gifts && oldId) {
                const sel = `[data-variant-id="${oldId}"]`;
                gifts.querySelectorAll(sel).forEach(update), gifts.querySelectorAll("template[data-gift-thumbs-source]").forEach(tpl => {
                    tpl.content && tpl.content.querySelectorAll(sel).forEach(update)
                })
            }
        }))
    }
    bindGiftPanel() {
        this._giftsBound || (this.addEventListener("click", event => {
            const progressGift = event.target.closest("[data-progress-gift-tier]");
            if (progressGift) {
                event.preventDefault(), this.focusGiftTier(progressGift.getAttribute("data-progress-gift-tier"));
                return
            }
            if (event.target.closest("[data-cart-gifts-collapse]")) {
                event.preventDefault(), this.closeGiftPanel();
                return
            }
            if (event.target.closest("[data-cart-gifts-reopen]")) {
                event.preventDefault(), this.openGiftPanel();
                return
            }
            const giftsPrev = event.target.closest("[data-gifts-prev]");
            if (giftsPrev) {
                event.preventDefault(), this.scrollGiftSlider(giftsPrev.closest("[data-gifts-slider]"), -1);
                return
            }
            const giftsNext = event.target.closest("[data-gifts-next]");
            if (giftsNext) {
                event.preventDefault(), this.scrollGiftSlider(giftsNext.closest("[data-gifts-slider]"), 1);
                return
            }
            if (event.target.closest("[data-gift-browse-all]")) {
                event.preventDefault(), this.closeGiftDetail();
                return
            }
            const sectionToggle = event.target.closest("[data-gift-section-toggle]");
            if (sectionToggle) {
                event.preventDefault();
                const section = sectionToggle.closest("[data-gift-tier]");
                section && this.toggleGiftSection(section);
                return
            }
            const detailThumb = event.target.closest("[data-gift-detail-thumb]");
            if (detailThumb) {
                event.preventDefault(), this.openGiftDetail(detailThumb);
                return
            }
            const giftAdd = event.target.closest("[data-gift-add]");
            if (giftAdd) {
                event.preventDefault(), event.stopPropagation(), this.claimGift(giftAdd);
                return
            }
            const openTrigger = event.target.closest("[data-gift-open-trigger]");
            if (openTrigger) {
                event.preventDefault();
                const card = openTrigger.closest("[data-gift-open]");
                card && this.openGiftDetail(card);
                return
            }
        }), this._giftsBound = !0), this._progressGiftKeydown || (this.addEventListener("keydown", event => {
            const progressGift = event.target.closest("[data-progress-gift-tier]");
            !progressGift || event.code !== "Enter" && event.code !== "Space" || (event.preventDefault(), this.focusGiftTier(progressGift.getAttribute("data-progress-gift-tier")))
        }), this._progressGiftKeydown = !0);
        const gifts = this.querySelector("[data-cart-gifts]");
        if (gifts) {
            if (this.bindGiftSliders(gifts), this._giftsCollapsed) {
                this.closeGiftPanel();
                return
            }
            this.classList.contains("active") || (gifts.classList.remove("is-open"), gifts.hidden = !0, this.classList.remove("gifts-open"))
        }
    }
    isMobileCart() {
        return window.matchMedia("(max-width: 749px)").matches
    }
    maybeAutoOpenGiftsAfterEligibilityChange() {
        const gifts = this.querySelector("[data-cart-gifts]");
        if (!gifts || !this.classList.contains("active")) return;
        const unlockedTiers = this.getUnlockedGiftTiers(),
            prevTiers = this._unlockedGiftTiers || [],
            newlyUnlocked = unlockedTiers.filter(tier => !prevTiers.includes(tier)),
            wasOpen = this.classList.contains("gifts-open") && !this._giftsCollapsed;
        if (this._unlockedGiftTiers = unlockedTiers, this._wasGiftEligible = unlockedTiers.length > 0 || gifts.dataset.autoOpen === "true", newlyUnlocked.length && !this.isMobileCart()) {
            this._giftsCollapsed = !1, this.focusGiftTier(newlyUnlocked[newlyUnlocked.length - 1]);
            return
        }
        wasOpen && this.openGiftPanel()
    }
    bindGiftSliders(root = this) {
        root.querySelectorAll("[data-gifts-slider]").forEach(slider => {
            const track = slider.querySelector("[data-gifts-track]");
            if (!track || (this.updateGiftSliderNav(slider), track.dataset.navScrollBound !== "true" && (track.dataset.navScrollBound = "true", track.addEventListener("scroll", () => this.updateGiftSliderNav(slider), {
                    passive: !0
                })), track.dataset.dragBound === "true")) return;
            track.dataset.dragBound = "true";
            let isPointerDown = !1,
                isDragging = !1,
                startX = 0,
                startScrollLeft = 0,
                pointerId = null;
            const endDrag = event => {
                if (isPointerDown && !(pointerId != null && event.pointerId !== pointerId)) {
                    isPointerDown = !1, track.classList.remove("is-dragging");
                    try {
                        pointerId != null && track.releasePointerCapture(pointerId)
                    } catch {}
                    pointerId = null, isDragging && (track.dataset.suppressClick = "true", window.setTimeout(() => {
                        delete track.dataset.suppressClick
                    }, 0)), isDragging = !1, this.updateGiftSliderNav(slider)
                }
            };
            track.addEventListener("pointerdown", event => {
                if (!(event.pointerType !== "mouse" || event.button !== 0) && !event.target.closest("[data-gift-add], [data-gift-open-trigger], [data-gift-detail-claim], [data-gift-variant-select], button, a, select, label")) {
                    isPointerDown = !0, isDragging = !1, pointerId = event.pointerId, startX = event.clientX, startScrollLeft = track.scrollLeft, track.classList.add("is-dragging");
                    try {
                        track.setPointerCapture(pointerId)
                    } catch {}
                }
            }), track.addEventListener("pointermove", event => {
                if (!isPointerDown || pointerId != null && event.pointerId !== pointerId) return;
                const dx = event.clientX - startX;
                !isDragging && Math.abs(dx) > 6 && (isDragging = !0), isDragging && (event.preventDefault(), track.scrollLeft = startScrollLeft - dx)
            }), track.addEventListener("pointerup", endDrag), track.addEventListener("pointercancel", endDrag), track.addEventListener("lostpointercapture", endDrag), track.addEventListener("click", event => {
                track.dataset.suppressClick === "true" && (event.preventDefault(), event.stopPropagation())
            }, !0)
        })
    }
    updateGiftSliderNav(slider) {
        const track = slider?.querySelector("[data-gifts-track]"),
            prev = slider?.querySelector("[data-gifts-prev]"),
            next = slider?.querySelector("[data-gifts-next]");
        if (!track || !prev || !next) return;
        if (!(track.scrollWidth > track.clientWidth + 1)) {
            prev.hidden = !0, next.hidden = !0;
            return
        }
        prev.hidden = track.scrollLeft <= 1, next.hidden = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth - 1
    }
    toggleGiftSection(section, forceExpand = null) {
        if (!section) return;
        const toggle = section.querySelector("[data-gift-section-toggle]");
        forceExpand ?? section.classList.contains("is-collapsed") ? (section.classList.remove("is-collapsed"), toggle?.setAttribute("aria-expanded", "true")) : (section.classList.add("is-collapsed"), toggle?.setAttribute("aria-expanded", "false"));
        const slider = section.querySelector("[data-gifts-slider]");
        slider && requestAnimationFrame(() => this.updateGiftSliderNav(slider))
    }
    openGiftPanel() {
        const gifts = this.querySelector("[data-cart-gifts]");
        gifts && (this.updateFooterOffset(), this._giftsCollapsed = !1, gifts.hidden = !1, requestAnimationFrame(() => {
            gifts.classList.add("is-open"), this.bindGiftSliders(gifts)
        }), this.classList.add("gifts-open"), this.classList.remove("has-gifts-collapsed"))
    }
    closeGiftPanel() {
        const gifts = this.querySelector("[data-cart-gifts]");
        gifts && (this.closeGiftDetail(), this.clearGiftTierFocus(), this._giftsCollapsed = !0, gifts.classList.remove("is-open"), gifts.hidden = !0, this.classList.remove("gifts-open"), this.classList.add("has-gifts-collapsed"))
    }
    clearGiftTierFocus() {
        this.querySelectorAll("[data-gift-tier].is-section-focused").forEach(section => {
            section.classList.remove("is-section-focused")
        })
    }
    focusGiftTier(tier) {
        if (!tier) return;
        this.openGiftPanel(), this.closeGiftDetail();
        const target = this.querySelector(`[data-gift-list] [data-gift-tier="${tier}"]`);
        target && (this.clearGiftTierFocus(), target.classList.add("is-section-focused"), target.classList.contains("cart-gifts__section--expandable") && this.toggleGiftSection(target, !0), requestAnimationFrame(() => {
            target.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            })
        }))
    }
    scrollGiftSlider(slider, direction) {
        const track = slider?.querySelector("[data-gifts-track]");
        if (!track) return;
        const amount = Math.max(track.clientWidth * .8, 160);
        track.scrollBy({
            left: amount * direction,
            behavior: "smooth"
        })
    }
    openGiftDetail(source) {
        const gifts = this.querySelector("[data-cart-gifts]"),
            detail = gifts?.querySelector("[data-gift-detail]");
        if (!gifts || !detail || !source) return;
        const card = source.matches?.("[data-gift-open]") ? source : source.closest("[data-gift-open]");
        if (!card) return;
        const cardImg = card.querySelector(".cart-gifts__media img"),
            title = card.dataset.giftProductTitle || "",
            label = card.dataset.giftLabel || "Free Gift",
            image = card.dataset.giftImage || cardImg?.currentSrc || cardImg?.src || "",
            images = (card.dataset.giftImages || image || "").split("|").map(url => url.trim()).filter(Boolean),
            wasPrice = card.dataset.giftWasPrice || "",
            locked = card.dataset.giftLocked === "true",
            canClaim = card.dataset.giftCanClaim === "true",
            away = card.dataset.giftAway || "",
            fill = Math.max(0, Math.min(100, Number(card.dataset.giftFill || 0))),
            tier = card.dataset.giftTier || "",
            variantId = card.dataset.variantId || "",
            heading = detail.querySelector("[data-gift-detail-heading]"),
            mainImage = detail.querySelector("[data-gift-detail-image]"),
            lock = detail.querySelector("[data-gift-detail-lock]"),
            titleEl = detail.querySelector("[data-gift-detail-title]"),
            wasEl = detail.querySelector("[data-gift-detail-was]"),
            awayEl = detail.querySelector("[data-gift-detail-away]"),
            fillEl = detail.querySelector("[data-gift-detail-fill]"),
            claimBtn = detail.querySelector("[data-gift-detail-claim]"),
            thumbs = detail.querySelector("[data-gift-detail-thumbs]"),
            gallery = detail.querySelector(".cart-gifts__detail-gallery");
        heading && (heading.textContent = away ? `${label} \xB7 ${away} away` : label), mainImage && (mainImage.src = images[0] || image, mainImage.alt = title), lock && (lock.hidden = !locked), titleEl && (titleEl.textContent = title), wasEl && (wasEl.textContent = wasPrice, wasEl.hidden = !wasPrice), awayEl && (awayEl.textContent = away ? `${away} away from this free gift` : "", awayEl.hidden = !away);
        const fillWidth = locked ? fill : 100;
        if (fillEl && (fillEl.style.width = `${fillWidth}%`), claimBtn && (claimBtn.dataset.variantId = variantId, claimBtn.dataset.giftTier = tier, claimBtn.dataset.giftLabel = label, claimBtn.disabled = !canClaim, claimBtn.textContent = canClaim || locked ? "Claim" : "Claimed"), thumbs) {
            thumbs.innerHTML = "";
            const template = gifts.querySelector(`template[data-gift-thumbs-source][data-gift-tier="${tier}"]`);
            if (template?.content && template.content.querySelectorAll("[data-gift-detail-thumb]").forEach(thumbBtn => {
                    const clone = thumbBtn.cloneNode(!0);
                    clone.querySelectorAll("img").forEach(img => {
                        const src = img.getAttribute("src") || img.getAttribute("data-src");
                        src && (img.removeAttribute("loading"), img.removeAttribute("data-src"), img.setAttribute("src", src), img.src = src)
                    }), String(clone.dataset.variantId) === String(variantId) ? clone.classList.add("is-active") : clone.classList.remove("is-active"), thumbs.appendChild(clone)
                }), !thumbs.children.length) {
                const tierSection = gifts.querySelector(`[data-gift-list] [data-gift-tier="${tier}"]`);
                (tierSection ? [...tierSection.querySelectorAll(".cart-gifts__card[data-gift-open]")] : []).forEach(sibling => {
                    const siblingImg = sibling.querySelector(".cart-gifts__media img"),
                        src = sibling.getAttribute("data-gift-image") || siblingImg?.getAttribute("src") || siblingImg?.currentSrc || siblingImg?.src || "";
                    if (!src) return;
                    const btn = document.createElement("button");
                    btn.type = "button", btn.className = "cart-gifts__detail-thumb", (sibling === card || String(sibling.dataset.variantId) === String(variantId)) && btn.classList.add("is-active"), btn.setAttribute("data-gift-detail-thumb", ""), btn.setAttribute("data-gift-open", ""), [...sibling.attributes].forEach(attr => {
                        attr.name.startsWith("data-") && btn.setAttribute(attr.name, attr.value)
                    });
                    const img = document.createElement("img");
                    img.src = src, img.alt = "", img.width = 48, img.height = 48, btn.appendChild(img), thumbs.appendChild(btn)
                })
            }
        }
        gallery && gallery.classList.toggle("cart-gifts__detail-gallery--no-thumbs", !thumbs?.children.length), detail.hidden = !1, gifts.classList.add("is-detail-open"), requestAnimationFrame(() => {
            const main = detail.querySelector(".cart-gifts__detail-main");
            thumbs && main?.offsetHeight && (thumbs.style.maxHeight = `${main.offsetHeight}px`, thumbs.style.height = `${main.offsetHeight}px`), thumbs?.querySelector(".is-active")?.scrollIntoView({
                block: "nearest",
                inline: "nearest"
            })
        })
    }
    closeGiftDetail() {
        const gifts = this.querySelector("[data-cart-gifts]"),
            detail = gifts?.querySelector("[data-gift-detail]");
        !gifts || !detail || (gifts.classList.remove("is-detail-open"), detail.hidden = !0)
    }
    async claimGift(button) {
        const variantId = button?.dataset?.variantId;
        if (!variantId || button.disabled) return;
        try {
            const cart = await this.stripStaleInternalCodes(await this.fetchCartJs());
            if (this.cartHasCustomerPromo(cart)) {
                const codes = this.getCustomerPromoCodes(cart);
                this.setGiftPromoBlockedUi(!0, codes[0]), window.alert("Free gifts can't be added while a discount code is applied. Remove the discount code to unlock free gifts.");
                return
            }
        } catch (error) {
            console.error(error);
            return
        }
        const tier = button.dataset.giftTier,
            tierSection = button.closest(".cart-gifts__section[data-gift-tier]") || (tier ? this.querySelector(`[data-gift-list] .cart-gifts__section[data-gift-tier="${tier}"]`) : null);
        if (tierSection?.dataset.giftClaimed === "true" || tierSection?.classList.contains("is-claimed")) return;
        button.disabled = !0;
        const label = button.innerHTML;
        button.textContent = "Adding\u2026";
        const keepGiftsOpen = this.classList.contains("gifts-open") || !this._giftsCollapsed;
        try {
            const giftLabel = button.dataset.giftLabel || "Free Gift",
                properties = {
                    _gift: "true",
                    _gift_tier: String(tier || "")
                };
            properties[giftLabel] = "Free Gift", await this.addVariantToCart(variantId, properties);
            const discounted = await this.applyGiftDiscount({
                withSections: !0
            });
            if (this._giftsCollapsed = !keepGiftsOpen, discounted?.sections) this.renderContents(discounted);
            else {
                const refreshed = await this.fetchCartDrawerSections();
                refreshed && this.renderContents(refreshed)
            }
            keepGiftsOpen && requestAnimationFrame(() => this.openGiftPanel())
        } catch (error) {
            console.error(error), button.disabled = !1, button.innerHTML = label
        }
    }
    getGiftDiscountCode() {
        const fromData = typeof this.dataset.giftDiscountCode == "string" ? this.dataset.giftDiscountCode : "",
            fromWindow = typeof window.cartGiftDiscountCode == "string" ? window.cartGiftDiscountCode : "";
        return String(fromData || fromWindow || "").trim()
    }
    normalizeDiscountCode(code) {
        return String(code || "").trim().toUpperCase()
    }
    getLegacyInternalGiftCodes() {
        return ["FREEGIFT"]
    }
    isInternalGiftDiscountCode(code) {
        const normalized = this.normalizeDiscountCode(code);
        if (!normalized) return !1;
        if (this.getLegacyInternalGiftCodes().includes(normalized)) return !0;
        const giftCode = this.normalizeDiscountCode(this.getGiftDiscountCode());
        return !!giftCode && normalized === giftCode
    }
    getCartDiscountCodes(cart) {
        return (cart?.discount_codes || []).filter(entry => typeof entry == "string" || entry?.applicable !== !1).map(entry => typeof entry == "string" ? entry : entry?.code).filter(Boolean)
    }
    getCustomerPromoCodes(cart) {
        return this.getCartDiscountCodes(cart).filter(code => !this.isInternalGiftDiscountCode(code))
    }
    cartHasCustomerPromo(cart) {
        return this.getCustomerPromoCodes(cart).length > 0
    }
    getStaleInternalCodes(cart) {
        const giftCode = this.normalizeDiscountCode(this.getGiftDiscountCode());
        return this.getCartDiscountCodes(cart).filter(code => this.isInternalGiftDiscountCode(code) && this.normalizeDiscountCode(code) !== giftCode)
    }
    async updateCartDiscounts(codes, {
        withSections = !1
    } = {}) {
        const body = {
            discount: (codes || []).filter(Boolean).join(",")
        };
        withSections && (body.sections = this.getSectionsToRender().map(section => section.id), body.sections_url = window.location.pathname);
        const updateUrl = `${window.routes.cart_update_url}`.replace(/\.js$/, "") + ".js",
            response = await fetch(updateUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify(body)
            }),
            parsed = await response.json().catch(() => null);
        if (!response.ok || !parsed || parsed.errors || parsed.status && parsed.status !== 200) throw new Error(parsed && (parsed.description || parsed.message) || "Unable to update discount codes");
        return parsed
    }
    async stripStaleInternalCodes(cart) {
        const stale = this.getStaleInternalCodes(cart);
        if (!stale.length || this._strippingStaleCodes) return cart;
        this._strippingStaleCodes = !0;
        try {
            const staleSet = new Set(stale.map(code => this.normalizeDiscountCode(code))),
                remaining = this.getCartDiscountCodes(cart).filter(code => !staleSet.has(this.normalizeDiscountCode(code))),
                updated = await this.updateCartDiscounts(remaining);
            return updated && Array.isArray(updated.items) ? updated : cart
        } catch (error) {
            return console.warn("Unable to remove stale gift discount code", error), cart
        } finally {
            this._strippingStaleCodes = !1
        }
    }
    async removeCustomerPromoCodes(trigger) {
        if (this._removingPromoCodes) return;
        this._removingPromoCodes = !0, trigger && (trigger.disabled = !0, trigger.setAttribute("aria-busy", "true"));
        const keepGiftsOpen = this.classList.contains("gifts-open") && !this._giftsCollapsed;
        try {
            let cart = null;
            try {
                cart = await this.fetchCartJs()
            } catch {
                cart = null
            }
            const giftCode = this.getGiftDiscountCode(),
                keep = giftCode && this.getCartDiscountCodes(cart).some(code => this.normalizeDiscountCode(code) === this.normalizeDiscountCode(giftCode)) ? [giftCode] : [];
            this.clearDiscountCodeCookie();
            let updated;
            try {
                updated = await this.updateCartDiscounts(keep, {
                    withSections: !0
                })
            } catch {
                await new Promise(resolve => setTimeout(resolve, 600)), updated = await this.updateCartDiscounts(keep, {
                    withSections: !0
                })
            }
            if (this.setGiftPromoBlockedUi(!1), updated?.sections) this.renderContents(updated), this.classList.toggle("is-empty", updated.item_count === 0);
            else {
                const refreshed = await this.fetchCartDrawerSections();
                refreshed && this.renderContents(refreshed)
            }
            requestAnimationFrame(() => {
                this.setGiftPromoBlockedUi(!1), keepGiftsOpen && this.openGiftPanel()
            })
        } catch (error) {
            console.error(error), trigger && (trigger.disabled = !1, trigger.removeAttribute("aria-busy")), window.alert("Sorry, we couldn't remove the discount code. Please try again.")
        } finally {
            this._removingPromoCodes = !1
        }
    }
    clearDiscountCodeCookie() {
        const names = ["discount_code"],
            host = window.location.hostname,
            parts = host.split("."),
            domains = new Set(["", host, `.${host}`]);
        for (let i = 1; i < parts.length - 1; i++) {
            const parent = parts.slice(i).join(".");
            domains.add(parent), domains.add(`.${parent}`)
        }
        const expires = "expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0";
        names.forEach(name => {
            domains.forEach(domain => {
                ["/", window.location.pathname].forEach(path => {
                    document.cookie = `${name}=; ${expires}; path=${path}${domain?`; domain=${domain}`:""}; SameSite=Lax`
                })
            })
        });
        try {
            sessionStorage.removeItem("discount_code"), localStorage.removeItem("discount_code")
        } catch {}
    }
    updateFooterOffset() {
        const footer = this.querySelector(".drawer__inner > .drawer__footer");
        if (this.classList.contains("is-empty") || !footer) {
            this.style.setProperty("--cart-drawer-footer-h", "0px");
            return
        }
        const height = footer.offsetHeight;
        height > 0 ? this.style.setProperty("--cart-drawer-footer-h", `${height}px`) : this.style.removeProperty("--cart-drawer-footer-h"), window.ResizeObserver && this._observedFooter !== footer && (this._footerObserver = this._footerObserver || new ResizeObserver(() => this.updateFooterOffset()), this._observedFooter && this._footerObserver.unobserve(this._observedFooter), this._footerObserver.observe(footer, {
            box: "border-box"
        }), this._observedFooter = footer)
    }
    markRendered() {
        this._lastRenderAt = Date.now()
    }
    onOverlayClick(event) {
        this.classList.contains("active") && (this._lastRenderAt && Date.now() - this._lastRenderAt < 450 || (event.preventDefault(), this.close()))
    }
    setGiftPromoBlockedUi(blocked, promoCode) {
        const gifts = this.querySelector("[data-cart-gifts]");
        if (!gifts) return;
        gifts.classList.toggle("is-promo-blocked", !!blocked), gifts.dataset.promoBlocked = blocked ? "true" : "false";
        let notice = gifts.querySelector("[data-gift-promo-notice]");
        if (!notice) {
            notice = document.createElement("div"), notice.className = "cart-gifts__promo-notice", notice.setAttribute("data-gift-promo-notice", ""), notice.setAttribute("role", "status");
            const header = gifts.querySelector(".cart-gifts__header");
            header ? header.insertAdjacentElement("afterend", notice) : gifts.prepend(notice)
        }
        if (blocked) {
            const codeLabel = promoCode ? ` (${promoCode})` : "",
                noticeKey = String(promoCode || "");
            if (notice.hidden = !1, notice.dataset.promoCode !== noticeKey || !notice.querySelector("[data-gift-promo-remove]")) {
                notice.dataset.promoCode = noticeKey, notice.textContent = "";
                const text = document.createElement("span");
                text.className = "cart-gifts__promo-notice-text", text.textContent = `Free gifts can't be combined with discount codes${codeLabel}. Remove the code to claim your free gifts.`;
                const removeBtn = document.createElement("button");
                removeBtn.type = "button", removeBtn.className = "cart-gifts__promo-remove", removeBtn.setAttribute("data-gift-promo-remove", ""), removeBtn.setAttribute("aria-label", promoCode ? `Remove discount code ${promoCode}` : "Remove discount code"), removeBtn.textContent = "Remove code", notice.append(text, " ", removeBtn)
            }
        } else notice.hidden = !0, notice.textContent = "", delete notice.dataset.promoCode;
        this.setGiftPromoCartNote(blocked, promoCode);
        gifts.querySelectorAll("[data-gift-add], [data-gift-detail-claim]").forEach(btn => {
            blocked ? (btn.dataset.promoPrevDisabled || (btn.dataset.promoPrevDisabled = btn.disabled ? "1" : "0"), btn.disabled = !0, btn.setAttribute("aria-disabled", "true")) : btn.dataset.promoPrevDisabled != null && (btn.disabled = btn.dataset.promoPrevDisabled === "1", btn.removeAttribute("aria-disabled"), delete btn.dataset.promoPrevDisabled)
        })
    }
    isPromoRemovableGiftLine(item) {
        const props = item?.properties || {};
        return String(props._gift) === "true" || String(props.__upez_free_gift) === "true"
    }
    cartHasPromoRemovableGift(cart) {
        return (cart?.items || []).some(item => this.isPromoRemovableGiftLine(item))
    }
    setGiftPromoCartNote(blocked, promoCode) {
        const footer = this.querySelector(".drawer__inner > .drawer__footer") || this.querySelector(".drawer__footer");
        let note = this.querySelector("[data-gift-promo-cart-note]");
        if (!blocked) {
            note && note.remove();
            return
        }
        if (!footer) return;
        note || (note = document.createElement("p"), note.className = "cart-gifts__promo-notice cart-gifts__promo-cart-note", note.setAttribute("data-gift-promo-cart-note", ""), note.setAttribute("role", "status"), note.style.margin = "0 0 1rem", note.style.fontSize = "1.25rem", footer.prepend(note));
        note.textContent = "Free gifts can't be combined with discount codes."
    }
    async removeAllGiftItems(cart) {
        const gifts = (cart?.items || []).filter(item => this.isPromoRemovableGiftLine(item));
        if (!gifts.length) return cart;
        const updates = {};
        if (gifts.forEach(item => {
                item.key && (updates[item.key] = 0)
            }), !Object.keys(updates).length) return cart;
        const body = {
                updates,
                sections: this.getSectionsToRender().map(section => section.id),
                sections_url: window.location.pathname
            },
            updateUrl = `${window.routes.cart_update_url}`.replace(/\.js$/, "") + ".js",
            response = await fetch(updateUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify(body)
            }),
            parsed = await response.json().catch(() => null);
        return !response.ok || !parsed || parsed.errors ? (console.warn("Unable to remove gifts for promo mutual exclusion", parsed), cart) : parsed
    }
    async syncGiftsWithCustomerPromo({
        withRender = !0
    } = {}) {
        if (this._syncingPromoGifts) return null;
        this._syncingPromoGifts = !0;
        try {
            let cart;
            try {
                cart = await this.fetchCartJs()
            } catch (error) {
                return console.error(error), null
            }
            cart = await this.stripStaleInternalCodes(cart);
            const promoCodes = this.getCustomerPromoCodes(cart),
                hasPromo = promoCodes.length > 0;
            if (this.setGiftPromoBlockedUi(hasPromo, promoCodes[0]), !hasPromo || !this.cartHasPromoRemovableGift(cart)) return cart;
            const cleaned = await this.removeAllGiftItems(cart);
            return withRender && cleaned?.sections && (this.renderContents(cleaned), this.classList.toggle("is-empty", cleaned.item_count === 0), requestAnimationFrame(() => {
                this.setGiftPromoBlockedUi(!0, promoCodes[0])
            })), cleaned
        } catch (error) {
            return console.error(error), null
        } finally {
            this._syncingPromoGifts = !1
        }
    }
    installCustomerPromoDiscountGuard() {
        if (window.__cartGiftPromoGuardInstalled) return;
        window.__cartGiftPromoGuardInstalled = !0;
        const originalFetch = window.fetch.bind(window);
        window.fetch = async (...args) => {
            try {
                const [input, init] = args, url = typeof input == "string" ? input : input?.url || "";
                if (String(init?.method || input?.method || "GET").toUpperCase() === "POST" && /\/cart\/update(\.js)?(\?|$)/.test(url) && typeof init?.body == "string") {
                    let payload = null;
                    try {
                        payload = JSON.parse(init.body)
                    } catch {
                        payload = null
                    }
                    const requestedCode = payload?.discount,
                        drawer = document.querySelector("cart-drawer");
                    if (requestedCode && drawer?.isInternalGiftDiscountCode && !drawer.isInternalGiftDiscountCode(requestedCode) && typeof drawer.removeAllGiftItems == "function") try {
                        const cart = await drawer.fetchCartJs();
                        (drawer.cartHasPromoRemovableGift ? drawer.cartHasPromoRemovableGift(cart) : drawer.cartHasGift(cart)) && (await drawer.removeAllGiftItems(cart), drawer.setGiftPromoBlockedUi?.(!0, requestedCode))
                    } catch (error) {
                        console.error(error)
                    }
                }
            } catch (error) {
                console.error(error)
            }
            return originalFetch(...args)
        }
    }
    cartHasPricedGift(cart) {
        return (cart?.items || []).some(item => {
            const props = item.properties || {};
            return String(props._gift) === "true" && Number(item.final_line_price) > 0
        })
    }
    cartHasGift(cart) {
        return (cart?.items || []).some(item => String(item.properties?._gift) === "true")
    }
    async fetchCartJs() {
        const response = await fetch(`${window.routes.cart_url}.js`, {
            headers: {
                Accept: "application/json"
            }
        });
        if (!response.ok) throw new Error("Unable to load cart");
        return response.json()
    }
    async fetchCartDrawerSections() {
        const response = await fetch(`${window.routes.cart_url}?sections=cart-drawer,cart-icon-bubble`);
        return response.ok ? {
            sections: await response.json()
        } : null
    }
    async autoApplyGiftDiscount() {
        return this._giftDiscountApplying ? null : this.applyGiftDiscount({
            withSections: !1
        })
    }
    async applyGiftDiscount({
        withSections = !1
    } = {}) {
        const code = this.getGiftDiscountCode();
        if (!code || this._giftDiscountApplying) return null;
        this._giftDiscountApplying = !0;
        try {
            let cart;
            try {
                cart = await this.fetchCartJs()
            } catch (error) {
                return console.error(error), null
            }
            if (!this.cartHasGift(cart) || this.cartHasCustomerPromo(cart) || !this.cartHasPricedGift(cart)) return null;
            const body = {
                discount: code
            };
            withSections && (body.sections = this.getSectionsToRender().map(section => section.id), body.sections_url = window.location.pathname);
            const updateUrl = `${window.routes.cart_update_url}`.replace(/\.js$/, "") + ".js",
                response = await fetch(updateUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: JSON.stringify(body)
                }),
                parsed = await response.json().catch(() => null);
            return response.ok ? parsed : (console.warn("Gift discount could not be applied", parsed), null)
        } catch (error) {
            return console.error(error), null
        } finally {
            this._giftDiscountApplying = !1
        }
    }
    ensureGiftDiscountBeforeCheckout(event) {
        const checkoutBtn = event.target.closest('#CartDrawer-Checkout, button[name="checkout"]');
        if (!checkoutBtn || !this.contains(checkoutBtn)) return;
        const code = this.getGiftDiscountCode();
        code && this.querySelector(".cart-item--gift") && (event.preventDefault(), event.stopImmediatePropagation(), checkoutBtn.disabled = !0, (async () => {
            try {
                await this.applyGiftDiscount();
                const cart = await this.fetchCartJs();
                if (this.cartHasPricedGift(cart)) {
                    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent("/checkout")}`;
                    return
                }
                checkoutBtn.disabled = !1, window.location.href = "/checkout"
            } catch (error) {
                console.error(error), window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent("/checkout")}`
            }
        })())
    }
    async addVariantToCart(variantId, properties) {
        const item = {
            id: Number(variantId),
            quantity: 1
        };
        properties && (item.properties = properties);
        const response = await fetch(`${window.routes.cart_add_url}.js`.replace(/\.js\.js$/, ".js"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify({
                    items: [item],
                    sections: this.getSectionsToRender().map(section => section.id),
                    sections_url: window.location.pathname
                })
            }),
            parsed = await response.json();
        if (!response.ok || parsed.status && parsed.status !== 200) throw new Error(parsed.description || parsed.message || "Unable to add item");
        return parsed
    }
    bindUpsellPanel() {
        this._upsellBound || (this.addEventListener("click", event => {
            const addButton = event.target.closest("[data-upsell-add]");
            if (addButton) {
                event.preventDefault(), this.addUpsellProduct(addButton);
                return
            }
            const nextButton = event.target.closest("[data-upsell-next]");
            if (nextButton) {
                event.preventDefault(), this.scrollUpsell(nextButton.closest("[data-cart-drawer-upsell]"), 1);
                return
            }
            const prevButton = event.target.closest("[data-upsell-prev]");
            prevButton && (event.preventDefault(), this.scrollUpsell(prevButton.closest("[data-cart-drawer-upsell]"), -1))
        }), this._upsellBound = !0);
        const section = this.querySelector("[data-cart-drawer-upsell]");
        if (section) {
            const track = section.querySelector("[data-upsell-track]"),
                limit = parseInt(section.dataset.upsellLimit, 10) || 8,
                cartIdSet = new Set((section.dataset.cartProductIds || "").split(",").map(id => Number(id.trim())).filter(Boolean));
            this.ensureUpsellVisible(section, track, limit, cartIdSet)
        }
        this.loadUpsellRecommendations()
    }
    shuffleArray(items) {
        const array = [...items];
        for (let i = array.length - 1; i > 0; i -= 1) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]]
        }
        return array
    }
    getUpsellFallbackHtml(section, limit) {
        const fallback = section.querySelector("template[data-upsell-fallback]") || this.querySelector("template[data-upsell-fallback]");
        return fallback?.content ? this.shuffleArray([...fallback.content.querySelectorAll(".cart-drawer-upsell__item")].map(item => item.outerHTML)).slice(0, limit) : []
    }
    getUpsellCartIdSet(section) {
        return new Set((section?.dataset.cartProductIds || "").split(",").map(id => Number(id.trim())).filter(Boolean))
    }
    filterUpsellHtml(html, cartIdSet) {
        if (!html) return "";
        const template = document.createElement("template");
        return template.innerHTML = html, template.content.querySelectorAll(".cart-drawer-upsell__item").forEach(item => {
            cartIdSet.has(Number(item.dataset.productId)) && item.remove()
        }), template.content.querySelector(".cart-drawer-upsell__item") ? template.innerHTML : ""
    }
    paintUpsellFromCache() {
        const section = this.querySelector("[data-cart-drawer-upsell]"),
            track = section?.querySelector("[data-upsell-track]");
        if (!section || !track || !this._upsellCacheHtml) return !1;
        if (track.dataset.upsellPainted === "true") return !0;
        const html = this.filterUpsellHtml(this._upsellCacheHtml, this.getUpsellCartIdSet(section));
        return html ? (track.innerHTML = html, track.dataset.upsellPainted = "true", section.hidden = !1, !0) : !1
    }
    ensureUpsellVisible(section, track, limit, cartIdSet) {
        return !section || !track || !this.paintUpsellFromCache() && !track.querySelector(".cart-drawer-upsell__item") ? !1 : (section.hidden = !1, delete section.dataset.upsellInit, this.initUpsellSliders(), this.updateUpsellNav(section), !0)
    }
    getUpsellCartKey(cart) {
        return `${(cart.items||[]).map(item=>`${item.product_id}:${item.quantity}:${String(item.properties?._gift)==="true"?"g":""}`).join("|")}#${cart.total_price}`
    }
    async loadUpsellRecommendations() {
        const section = this.querySelector("[data-cart-drawer-upsell]"),
            track = section?.querySelector("[data-upsell-track]");
        if (!section || !track) return;
        const limit = parseInt(section.dataset.upsellLimit, 10) || 8;
        this.ensureUpsellVisible(section, track, limit, this.getUpsellCartIdSet(section));
        const requestId = this._upsellRequestId = (this._upsellRequestId || 0) + 1;
        let cart = null;
        try {
            cart = await this.fetchCartJs()
        } catch (error) {
            console.error(error)
        }
        if (requestId !== this._upsellRequestId || !cart?.items?.length) return;
        const cartKey = this.getUpsellCartKey(cart);
        if (this._upsellLoadedKey === cartKey && this._upsellCacheHtml) return;
        let picks = [];
        try {
            picks = await this.buildUpsellPicks(cart, section, limit)
        } catch (error) {
            console.error(error)
        }
        if (requestId !== this._upsellRequestId) return;
        const liveSection = this.querySelector("[data-cart-drawer-upsell]"),
            liveTrack = liveSection?.querySelector("[data-upsell-track]");
        if (!liveSection || !liveTrack) return;
        const cartIdSet = new Set((cart.items || []).map(item => Number(item.product_id)));
        let html = picks.map((pick, index) => this.renderUpsellCard(pick, index)).join(""),
            source = "context";
        if (!html) {
            source = "fallback";
            try {
                html = await this.getLegacyUpsellHtml(liveSection, limit, cartIdSet)
            } catch (error) {
                console.error(error), html = ""
            }
            if (requestId !== this._upsellRequestId) return
        }
        if (!html) {
            this.ensureUpsellVisible(liveSection, liveTrack, limit, cartIdSet);
            return
        }
        liveTrack.innerHTML !== html && (liveTrack.innerHTML = html), liveTrack.dataset.upsellPainted = "true", liveTrack.dataset.upsellSource = source, liveSection.hidden = !1, this._upsellCacheHtml = html, this._upsellLoadedKey = cartKey, this._upsellDebug = {
            source,
            picks
        }, delete liveSection.dataset.upsellInit, this.initUpsellSliders(), this.updateUpsellNav(liveSection), requestAnimationFrame(() => this.updateUpsellNav(liveSection))
    }
    async getLegacyUpsellHtml(section, limit, cartIdSet) {
        const recommendationsUrl = section.dataset.recommendationsUrl,
            intent = section.dataset.upsellIntent || "related",
            productIds = [...cartIdSet].map(String),
            collected = new Map;
        productIds.length && recommendationsUrl && (await Promise.all(this.shuffleArray(productIds).slice(0, 2).map(async productId => {
            try {
                const url = `${recommendationsUrl}?section_id=cart-drawer-upsell&product_id=${productId}&limit=${limit}&intent=${intent}`,
                    response = await fetch(url);
                return response.ok ? [...new DOMParser().parseFromString(await response.text(), "text/html").querySelectorAll(".cart-drawer-upsell__item")] : []
            } catch (error) {
                return console.error(error), []
            }
        }))).flat().forEach(item => {
            const id = Number(item.dataset.productId);
            !id || cartIdSet.has(id) || collected.has(id) || collected.set(id, item.outerHTML)
        });
        const items = [...collected.values()];
        for (const html of this.getUpsellFallbackHtml(section, limit)) {
            if (items.length >= limit) break;
            const match = html.match(/data-product-id="(\d+)"/),
                id = match ? Number(match[1]) : null;
            !id || cartIdSet.has(id) || collected.has(id) || (collected.set(id, html), items.push(html))
        }
        return items.slice(0, limit).join("")
    }
    getUpsellRoot(section) {
        const root = window.Shopify?.routes?.root || section?.dataset.upsellRoot || "/";
        return root.endsWith("/") ? root : `${root}/`
    }
    getUpsellTiers(section) {
        try {
            return (JSON.parse(section?.dataset.upsellTiers || "[]") || []).map(tier => ({
                threshold: Number(tier.threshold) || 0,
                label: String(tier.label || "")
            })).filter(tier => tier.threshold > 0 && tier.label).sort((a, b) => a.threshold - b.threshold)
        } catch {
            return []
        }
    }
    shortUpsellTierLabel(label) {
        return String(label || "").replace("Free Standard Shipping", "Free Shipping").replace("Free Premium Gift", "Premium Gift").replace("Extra Premium Gift", "VIP Gift")
    }
    formatUpsellMoney(cents) {
        const dollars = (Number(cents) || 0) / 100;
        return `$${Number.isInteger(dollars)?dollars:dollars.toFixed(2)}`
    }
    upsellNorm(value) {
        return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, "")
    }
    upsellFamily(type) {
        const t = String(type || "").toLowerCase();
        return /shampoo|conditioner|hair|scalp/.test(t) ? "hair" : /body|hand cream|hand wash|deodorant/.test(t) ? "body" : /cushion|foundation|make ?up|concealer|mascara|brow|powder|blush|lip tint/.test(t) ? "makeup" : /device|tool|vitamin|supplement|tablet/.test(t) ? "other" : "face"
    }
    normalizeUpsellProduct(product) {
        if (!product || !product.id) return null;
        const toCents = value => typeof value == "number" ? Math.round(value) : Math.round(parseFloat(value || 0) * 100) || 0,
            variants = Array.isArray(product.variants) ? product.variants : [],
            firstAvailable = variants.find(variant => variant.available) || null,
            image = typeof product.featured_image == "string" ? product.featured_image : product.featured_image?.url || (typeof product.image == "string" ? product.image : "") || "",
            tags = Array.isArray(product.tags) ? product.tags : String(product.tags || "").split(",").map(tag => tag.trim()).filter(Boolean);
        return {
            id: Number(product.id),
            title: product.title || "",
            handle: product.handle || "",
            vendor: product.vendor || "",
            type: product.type || product.product_type || "",
            tags,
            available: product.available !== !1 && (!variants.length || !!firstAvailable),
            price: toCents(firstAvailable ? firstAvailable.price : product.price_min ?? product.price),
            variantId: firstAvailable ? Number(firstAvailable.id) : null,
            shippingless: variants.length > 0 && variants.every(variant => variant.requires_shipping === !1),
            image
        }
    }
    async fetchUpsellJson(cacheKey, url, mapper) {
        const storageKey = `cdu:v2:${cacheKey}`;
        try {
            const cached = JSON.parse(sessionStorage.getItem(storageKey) || "null");
            if (cached && Date.now() - cached.t < 1800 * 1e3) return cached.d
        } catch {}
        if (this._upsellInflight = this._upsellInflight || new Map, this._upsellInflight.has(storageKey)) return this._upsellInflight.get(storageKey);
        const request = fetch(url, {
            headers: {
                Accept: "application/json"
            }
        }).then(response => response.ok ? response.json() : null).then(json => {
            const data = json ? mapper(json) : [];
            try {
                sessionStorage.setItem(storageKey, JSON.stringify({
                    t: Date.now(),
                    d: data
                }))
            } catch {}
            return data
        }).catch(() => []).finally(() => this._upsellInflight.delete(storageKey));
        return this._upsellInflight.set(storageKey, request), request
    }
    fetchUpsellRecs(root, productId, intent) {
        return this.fetchUpsellJson(`${intent}:${productId}`, `${root}recommendations/products.json?product_id=${productId}&limit=10&intent=${intent}`, json => (json.products || []).map(product => this.normalizeUpsellProduct(product)).filter(Boolean))
    }
    fetchUpsellBrand(root, vendor) {
        const params = new URLSearchParams({
                q: vendor,
                "resources[type]": "product",
                "resources[limit]": "10",
                "resources[options][unavailable_products]": "hide",
                "resources[options][fields]": "vendor"
            }),
            target = this.upsellNorm(vendor);
        return this.fetchUpsellJson(`brand:${target}`, `${root}search/suggest.json?${params}`, json => (json.resources?.results?.products || []).map(product => this.normalizeUpsellProduct(product)).filter(product => product && this.upsellNorm(product.vendor) === target))
    }
    fetchUpsellProduct(root, handle) {
        return this.fetchUpsellJson(`product:${handle}`, `${root}products/${encodeURIComponent(handle)}.js`, json => {
            const product = this.normalizeUpsellProduct(json);
            return product ? [product] : []
        }).then(list => list[0] || null)
    }
    isUpsellEligible(product, cartIds, giftIds) {
        if (!product || !product.id || cartIds.has(product.id) || giftIds.has(product.id) || !product.available || !(product.price >= 1e3)) return !1;
        const handle = product.handle.toLowerCase(),
            title = product.title.toLowerCase().trim(),
            handleWithoutClaims = handle.replace(/(fragrance|oil|alcohol|paraben|sulfate|sulphate|silicone|cruelty|gluten|scent|sugar|bubble|stress|irritation|residue)-free/g, "");
        return !(/-free(-\d+)?$/.test(handle) || handleWithoutClaims.includes("-free") || /\bfree\)?$/.test(title) || /\(free\)|free gift|gift with purchase/.test(title) || product.tags.some(tag => /free ?gift|free-gift|gift with purchase|gwp|cart reward/i.test(tag)) || product.shippingless || /gift ?card/.test(`${product.type} ${handle} ${title}`.toLowerCase()))
    }
    async buildUpsellPicks(cart, section, limit) {
        const root = this.getUpsellRoot(section),
            isGiftLine = item => String(item.properties?._gift) === "true",
            lines = (cart.items || []).filter(item => !isGiftLine(item));
        if (!lines.length) return [];
        const norm = value => this.upsellNorm(value),
            cartIds = new Set((cart.items || []).map(item => Number(item.product_id))),
            giftIds = new Set((section.dataset.upsellGiftIds || "").split(",").map(id => Number(id.trim())).filter(Boolean)),
            cartVendors = new Set(lines.map(item => norm(item.vendor)).filter(Boolean)),
            cartTypes = new Set(lines.map(item => norm(item.product_type)).filter(Boolean)),
            cartFamilies = new Set(lines.map(item => this.upsellFamily(item.product_type))),
            unitPrices = lines.map(item => Number(item.final_price ?? item.price) || 0).filter(price => price > 0).sort((a, b) => a - b),
            refPrice = unitPrices[Math.floor(unitPrices.length / 2)] || 3e3,
            giftTotal = (cart.items || []).filter(item => isGiftLine(item) || !!item.selling_plan_allocation).reduce((sum, item) => sum + (item.final_line_price || 0), 0), /* ABB 11 Oct 2026: Replenish & Save lines excluded from tier math */
            eligibleTotal = Math.max(0, (cart.total_price || 0) - giftTotal),
            tiers = this.getUpsellTiers(section),
            nextTier = tiers.find(tier => eligibleTotal < tier.threshold),
            gap = nextTier ? nextTier.threshold - eligibleTotal : 0,
            seeds = [];
        [...lines].sort((a, b) => (b.final_price || 0) - (a.final_price || 0)).forEach(item => {
            seeds.length < 4 && !seeds.some(seed => seed.product_id === item.product_id) && seeds.push(item)
        });
        const vendors = [];
        seeds.forEach(seed => {
            seed.vendor && vendors.length < 2 && !vendors.some(vendor => norm(vendor) === norm(seed.vendor)) && vendors.push(seed.vendor)
        });
        const tasks = [];
        seeds.forEach(seed => {
            ["complementary", "related"].forEach(intent => {
                tasks.push(this.fetchUpsellRecs(root, seed.product_id, intent).then(list => ({
                    seed: seed.product_id,
                    source: intent,
                    list
                })))
            })
        }), vendors.forEach(vendor => {
            tasks.push(this.fetchUpsellBrand(root, vendor).then(list => ({
                seed: `brand:${vendor}`,
                source: "brand",
                list
            })))
        });
        const results = await Promise.all(tasks),
            weights = {
                complementary: 3,
                related: 2,
                brand: .75
            },
            candidates = new Map;
        results.forEach(({
            seed,
            source,
            list
        }) => {
            (list || []).forEach((product, index) => {
                if (!this.isUpsellEligible(product, cartIds, giftIds)) return;
                let candidate = candidates.get(product.id);
                candidate ? !candidate.product.variantId && product.variantId && (candidate.product = product) : (candidate = {
                    product,
                    seeds: new Set,
                    sources: new Set,
                    sourceScore: 0
                }, candidates.set(product.id, candidate)), candidate.sources.add(source), source !== "brand" && candidate.seeds.add(seed), candidate.sourceScore = Math.max(candidate.sourceScore, weights[source] * (1 - Math.min(index, 10) / 12))
            })
        });
        const scored = [...candidates.values()].map(candidate => {
                const product = candidate.product,
                    family = this.upsellFamily(product.type),
                    sameBrand = !!norm(product.vendor) && cartVendors.has(norm(product.vendor)),
                    sameType = !!norm(product.type) && cartTypes.has(norm(product.type)),
                    closeness = Math.max(0, 1 - Math.abs(Math.log(product.price / refPrice)) / Math.log(3));
                let score = candidate.sourceScore + 1.5 * Math.max(0, candidate.seeds.size - 1);
                sameBrand && (score += 3), sameType && (score += 1.5), cartFamilies.has(family) ? score += 1 : family !== "face" && (score -= 3), score += 2 * closeness, product.price > refPrice * 3 && product.price > 1e4 && (score -= 2);
                let closesGap = !1;
                gap > 0 && product.price >= gap && (closesGap = product.price <= gap + 2500, score += closesGap ? 3 : .5);
                const unlocks = tiers.filter(tier => eligibleTotal < tier.threshold && eligibleTotal + product.price >= tier.threshold);
                return {
                    ...product,
                    score,
                    closeness,
                    sameBrand,
                    sameType,
                    closesGap,
                    frequency: candidate.seeds.size,
                    sources: [...candidate.sources],
                    unlock: unlocks.length ? unlocks[unlocks.length - 1].label : ""
                }
            }),
            scoredById = new Map(scored.map(candidate => [candidate.id, candidate])),
            pinned = [];
        seeds.forEach(seed => {
            (results.find(entry => entry.seed === seed.product_id && entry.source === "complementary")?.list || []).forEach(product => {
                const candidate = product && scoredById.get(product.id);
                candidate && !pinned.includes(candidate) && pinned.length < limit && (candidate.pinned = !0, pinned.push(candidate))
            })
        });
        const picks = [...pinned],
            typeCount = new Map;
        pinned.forEach(candidate => typeCount.set(norm(candidate.type), (typeCount.get(norm(candidate.type)) || 0) + 1));
        const pool = scored.filter(candidate => !candidate.pinned);
        for (; picks.length < limit && pool.length;) {
            let bestIndex = 0,
                bestScore = -1 / 0;
            pool.forEach((candidate, index) => {
                const adjusted = candidate.score - .75 * (typeCount.get(norm(candidate.type)) || 0);
                (adjusted > bestScore + 1e-9 || Math.abs(adjusted - bestScore) <= 1e-9 && candidate.closeness > pool[bestIndex].closeness) && (bestScore = adjusted, bestIndex = index)
            });
            const [chosen] = pool.splice(bestIndex, 1);
            typeCount.set(norm(chosen.type), (typeCount.get(norm(chosen.type)) || 0) + 1), picks.push(chosen)
        }
        return (await Promise.all(picks.map(async pick => {
            if (pick.variantId) return pick;
            const full = await this.fetchUpsellProduct(root, pick.handle);
            if (!full || !full.variantId || !this.isUpsellEligible(full, cartIds, giftIds)) return null;
            const unlocks = tiers.filter(tier => eligibleTotal < tier.threshold && eligibleTotal + full.price >= tier.threshold);
            return {
                ...pick,
                price: full.price,
                variantId: full.variantId,
                image: pick.image || full.image,
                unlock: unlocks.length ? unlocks[unlocks.length - 1].label : ""
            }
        }))).filter(Boolean)
    }
    upsellImageUrl(src, width) {
        if (!src) return "";
        try {
            const url = new URL(src.startsWith("//") ? `https:${src}` : src, window.location.origin);
            return url.searchParams.set("width", String(width)), url.toString()
        } catch {
            return src
        }
    }
    renderUpsellCard(pick, index = 0) {
        const escape = value => String(value ?? "").replace(/[&<>"']/g, char => ({
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#39;"
            })[char]),
            url = `${this.getUpsellRoot(this.querySelector("[data-cart-drawer-upsell]"))}products/${pick.handle}`,
            image400 = this.upsellImageUrl(pick.image, 400),
            image200 = this.upsellImageUrl(pick.image, 200),
            price = this.formatUpsellMoney(pick.price),
            hint = pick.unlock ? `<p class="cart-drawer-upsell__hint">Adds ${escape(price)}, unlocks ${escape(this.shortUpsellTierLabel(pick.unlock))}</p>` : "",
            media = image400 ? `<img src="${escape(image400)}" srcset="${escape(image200)} 200w, ${escape(image400)} 400w" sizes="145px" alt="${escape(pick.title)}" width="400" height="400" loading="${index<3?"eager":"lazy"}">` : "";
        return `<li class="cart-drawer-upsell__item" data-product-id="${pick.id}" data-upsell-score="${pick.score.toFixed(2)}"><article class="cart-drawer-upsell__card"><a href="${escape(url)}" class="cart-drawer-upsell__media">${media}</a><div class="cart-drawer-upsell__info"><a href="${escape(url)}" class="cart-drawer-upsell__title">${escape(pick.title)}</a><p class="cart-drawer-upsell__price">${escape(price)}</p>${hint}<button type="button" class="cart-drawer-upsell__add" data-upsell-add data-variant-id="${pick.variantId}" aria-label="Add ${escape(pick.title)} to cart">ADD</button></div></article></li>`
    }
    initUpsellSliders() {
        this.querySelectorAll("[data-cart-drawer-upsell]").forEach(section => {
            section.dataset.upsellInit !== "true" && (section.dataset.upsellInit = "true", this.updateUpsellNav(section), section.querySelector("[data-upsell-track]")?.addEventListener("scroll", () => {
                this.updateUpsellNav(section)
            }))
        })
    }
    scrollUpsell(section, direction) {
        const track = section?.querySelector("[data-upsell-track]"),
            item = track?.querySelector(".cart-drawer-upsell__item");
        if (!track || !item) return;
        const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        track.scrollBy({
            left: direction * (item.offsetWidth + gap),
            behavior: "smooth"
        })
    }
    updateUpsellNav(section) {
        const track = section?.querySelector("[data-upsell-track]"),
            prev = section?.querySelector("[data-upsell-prev]"),
            next = section?.querySelector("[data-upsell-next]");
        if (!track || !prev || !next) return;
        if (!(track.scrollWidth > track.clientWidth + 1)) {
            prev.hidden = !0, next.hidden = !0;
            return
        }
        prev.hidden = track.scrollLeft <= 1, next.hidden = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth
    }
    async syncIneligibleGiftsOnOpen() {
        const cartItems = this.querySelector("cart-drawer-items");
        if (!(!cartItems?.removeIneligibleGifts || this._syncingGiftsOnOpen)) {
            this._syncingGiftsOnOpen = !0;
            try {
                const cart = await this.fetchCartJs();
                if (!this.cartHasGift(cart)) return;
                const cleaned = await cartItems.removeIneligibleGifts(cart);
                if (!cleaned || cleaned === cart || !(cart.items || []).some(item => String(item.properties?._gift) !== "true" ? !1 : !(cleaned.items || []).some(next => next.key === item.key))) return;
                if (cleaned.sections) this.renderContents(cleaned), this.classList.toggle("is-empty", cleaned.item_count === 0);
                else {
                    const refreshed = await this.fetchCartDrawerSections();
                    refreshed && (this.renderContents(refreshed), this.classList.toggle("is-empty", (cleaned.item_count || 0) === 0))
                }
            } catch (error) {
                console.error(error)
            } finally {
                this._syncingGiftsOnOpen = !1
            }
        }
    }
    async addUpsellProduct(button) {
        const variantId = button?.dataset?.variantId;
        if (!variantId || button.disabled) return;
        button.disabled = !0;
        const label = button.textContent;
        button.textContent = "Adding\u2026";
        try {
            const parsed = await this.addVariantToCart(variantId);
            this.renderContents(parsed)
        } catch (error) {
            console.error(error), button.disabled = !1, button.textContent = label
        }
    }
    open(triggeredBy) {
        triggeredBy && this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        cartDrawerNote && !cartDrawerNote.hasAttribute("role") && this.setSummaryAccessibility(cartDrawerNote);
        const layout = this.querySelector(".cart-drawer__layout");
        !this.classList.contains("active") && layout && (layout.style.transition = "none", layout.style.transform = window.matchMedia("(max-width: 749px)").matches ? "translate3d(0, 110%, 0)" : "", layout.offsetWidth, layout.style.transition = "", layout.style.transform = ""), requestAnimationFrame(() => {
            this.classList.add("animate", "active"), this.updateFooterOffset();
            const gifts = this.querySelector("[data-cart-gifts]"),
                unlockedTiers = this.getUnlockedGiftTiers(),
                keepGiftsOpen = !this._giftsCollapsed && this.classList.contains("gifts-open");
            this._wasGiftEligible = gifts?.dataset.autoOpen === "true", this._unlockedGiftTiers = unlockedTiers, keepGiftsOpen || !this.isMobileCart() && gifts?.dataset.autoOpen === "true" && !this._giftsCollapsed ? this.openGiftPanel() : gifts && (gifts.classList.remove("is-open"), gifts.hidden = !0, this.classList.remove("gifts-open")), this.loadUpsellRecommendations(), this.autoApplyGiftDiscount(), this.syncGiftsWithCustomerPromo(), this.syncIneligibleGiftsOnOpen(), requestAnimationFrame(() => {
                const upsell = this.querySelector("[data-cart-drawer-upsell]");
                upsell && (this.ensureUpsellVisible(upsell, upsell.querySelector("[data-upsell-track]"), parseInt(upsell.dataset.upsellLimit, 10) || 8, new Set((upsell.dataset.cartProductIds || "").split(",").map(id => Number(id.trim())).filter(Boolean))), this.updateUpsellNav(upsell))
            })
        }), this.addEventListener("transitionend", event => {
            if (layout && event.target !== layout) return;
            const containerToTrapFocusOn = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer"),
                focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
            trapFocus(containerToTrapFocusOn, focusElement)
        }, {
            once: !0
        }), document.body.classList.add("overflow-hidden"), document.body.classList.add("cart-drawer-open")
    }
    close() {
        this.classList.remove("active");
        const gifts = this.querySelector("[data-cart-gifts]");
        gifts && (gifts.classList.remove("is-open"), gifts.hidden = !0), this._giftsCollapsed = !1, this.classList.remove("gifts-open", "has-gifts-collapsed"), removeTrapFocus(this.activeElement), document.body.classList.remove("overflow-hidden"), document.body.classList.remove("cart-drawer-open")
    }
    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute("role", "button"), cartDrawerNote.setAttribute("aria-expanded", "false"), cartDrawerNote.nextElementSibling.getAttribute("id") && cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id), cartDrawerNote.addEventListener("click", event => {
            event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"))
        }), cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape)
    }
    renderContents(parsedState) {
        this.querySelector(".drawer__inner")?.classList.remove("is-empty"), this.productId = parsedState.id, this.markRendered();
        const itemsScrollTop = this.classList.contains("active") && this.querySelector("cart-drawer-items")?.scrollTop || 0;
        this.captureProgressFill(), this.getSectionsToRender().forEach(section => {
            if (!parsedState.sections?.[section.id]) return;
            if (section.id === "cart-icon-bubble") {
                const html = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector || ".shopify-section");
                document.querySelectorAll("#cart-icon-bubble, a.abb-header__icon--cart, .js-cart-icon-bubble").forEach(el => {
                    el.innerHTML = html
                });
                return
            }
            const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            if (sectionElement) try {
                sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
            } catch (error) {
                console.error(error)
            }
        });
        const itemsScroller = this.querySelector("cart-drawer-items");
        itemsScroller && itemsScrollTop && (itemsScroller.scrollTop = itemsScrollTop), this.paintUpsellFromCache(), setTimeout(() => {
            this.updateFooterOffset(), this.bindGiftPanel(), this.bindUpsellPanel(), this.animateProgressFill(), this.open()
        })
    }
    getSectionInnerHTML(html, selector = ".shopify-section") {
        const doc = new DOMParser().parseFromString(html, "text/html"),
            el = doc.querySelector(selector) || doc.querySelector(".shopify-section");
        return el ? el.innerHTML : html
    }
    getSectionsToRender() {
        return [{
            id: "cart-drawer",
            selector: "#CartDrawer"
        }, {
            id: "cart-icon-bubble"
        }]
    }
    getSectionDOM(html, selector = ".shopify-section") {
        return new DOMParser().parseFromString(html, "text/html").querySelector(selector)
    }
    setActiveElement(element) {
        this.activeElement = element
    }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [{
            id: "CartDrawer",
            section: "cart-drawer",
            selector: "#CartDrawer"
        }, {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section"
        }]
    }
}
customElements.define("cart-drawer-items", CartDrawerItems);
//# sourceMappingURL=/cdn/shop/t/77/assets/cart-drawer.js.map?v=153587851527470136001791115463
